import moment from 'moment';
import { formatPolicyStatus, formatCancellationSubstatusLabel } from 'utils/policyStatus';
import { formatCPF, formatPlate } from 'react-data-formatter';
import { formatCurrency } from 'react-data-formatter';
import { translatePolicyModality } from 'utils/policyModality';

export const dataColumns = [
  {
    name: 'ID',
    selector: (row) => row?.id,
    width: '7%',
    sortable: true,
  },
  {
    name: 'Cliente',
    selector: (row) => row?.user?.name,
    width: '13%',
    sortable: true,
  },
  {
    name: 'CPF',
    selector: (row) => formatCPF(row?.user?.cpf),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Placa',
    selector: (row) => formatPlate(row?.vehicle?.plate),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Valor',
    selector: (row) => formatCurrency(row?.value_final || 0),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Protocolo',
    selector: (row) => row?.policy_number,
    width: '15%',
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => formatPolicyStatus(row?.status)?.label,
    width: '10%',
    sortable: true,
  },
  {
    name: 'Modalidade',
    selector: (row) => translatePolicyModality(row?.policy_modality),
    width: '10%',
    sortable: true,
  },
  {
    name: 'Substatus',
    selector: (row) => {
      if (row?.status !== 'canceled') return '—';
      return formatCancellationSubstatusLabel(row?.substatus) || '—';
    },
    width: '10%',
    sortable: true,
  },
  {
    name: 'Agente de vendas',
    selector: (row) => row?.author?.name,
    width: '15%',
    sortable: true,
  },

  {
    name: 'Enviada em',
    selector: (row) => moment.utc(row?.created_at).format('DD/MM/YYYY HH:mm'),
    width: '10%',
    sortable: true,
  },
];
